export const setWindowVar = (varName: string, varValue: string) => {
  // @ts-ignore
  window[varName] = varValue;
};

export function setupVersion() {
  // @ts-ignore
  const applicationVersion = __APPLICATION_VERSION__ || '0.0.0';
  // @ts-ignore
  const buildNumber = __BUILD_NUMBER__ || 'local';

  // @ts-ignore
  setWindowVar('version', `${applicationVersion}.${buildNumber}`);
}
